/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "api": {
            "nested": {
              "sandbox": {
                "nested": {
                  "MagicValue": {
                    "values": {
                      "PaymentApprovedConnectionError": 1,
                      "PaymentDeclineCompliance": 2,
                      "PaymentDeclineInsufficientFunds": 3,
                      "PaymentDeclineOther": 4,
                      "PaymentDeclineRisk": 5,
                      "PaymentDeclineTooLarge": 6,
                      "PaymentDeclineTooSmall": 7,
                      "PaymentDeclineGrantConsumed": 8,
                      "PaymentDeclineGrantExpired": 9,
                      "PaymentDeclineGrantMissing": 10,
                      "PaymentDeclineGrantRevoked": 11,
                      "PaymentCreationFailureMerchantDisabled": 12,
                      "PaymentCreationFailureMerchantPending": 13,
                      "PaymentCreationFailureMerchantMissing": 14,
                      "RefundApprovedConnectionError": 1000,
                      "RefundDeclineCompliance": 1001,
                      "RefundDeclineOther": 1002,
                      "RefundDeclineRisk": 1003,
                      "RefundDeclineTooLarge": 1004,
                      "RefundDeclineTooSmall": 1005,
                      "RefundDeclineGrantConsumed": 1006,
                      "RefundDeclineGrantExpired": 1007,
                      "RefundDeclineGrantMissing": 1008,
                      "RefundDeclineGrantRevoked": 1009,
                      "RefundCreationFailureMerchantDisabled": 1010,
                      "RefundCreationFailureMerchantMissing": 1011,
                      "RefundCreationFailureMerchantPending": 1012,
                      "CreateDisputeCD10": 2000,
                      "CreateDisputeCD11": 2001,
                      "CreateDisputeCD12": 2002,
                      "CreateDisputeCD13": 2003,
                      "CreateDisputeFR10": 2004,
                      "CreateDisputeFR11": 2005,
                      "CreateDisputePE10": 2006,
                      "CreateDisputePE11": 2007,
                      "CreateDisputePE12": 2008,
                      "CreateDisputeAmountDifferent": 2009,
                      "CustomerRequestFailureCustomerIneligible": 3000
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.api?.nested?.sandbox?.nested?.MagicValue) {
  $root.addJSON(jsonData);
}

/**
 * Describes the possible errors partners can trigger the API to return in sandbox using the Cash App Pay sandbox app.
 * Note: These protos will be serialized in Merbro's payment context so please use caution before modifying or removing
 * any fields. If you have any questions feel free to reach out to #cash-dap-team on slack.
 *
 * SOURCE MagicValue @ squareup/cash/api/sandbox/magic_value.proto at 11:1
 */
export const MagicValue = $root.lookupEnum('squareup.cash.api.sandbox.MagicValue').values;